import { transformThemeToDefaultAssets } from 'config/theme-transformation-utils';
import type { Core } from 'core/config/types';
import { getDefaultOptions } from 'model/board/get-default-options';

/**
 * Replaces pieces assets with fallback version
 * @param context
 */
export function setPiecesFallback(context: Core.Context) {
  if (context.options.themeAssets) {
    context.api.setOptions({
      themeAssets: transformThemeToDefaultAssets(context.options.themeAssets),
    });
    return;
  }

  context.options.pieceStyle = getDefaultOptions().pieceStyle;
  context.renderer?.updatePieceBaseImage(context, true);
}
